export default class PaysafeError extends Error {
  
  static type = "PaysafeError";
  
  constructor(stage, error) {
    super(`PaysafeError: ${stage}: [${error.code}] ${error.detailedMessage}`);
    this.stage = stage;
    this.originalError = error;
    this.code = error.code;
    this.displayMessage = error.displayMessage;
    this.detailedMessage = error.detailedMessage;
    this.type = PaysafeError.type;
    // expose details property for BB reporting
    this.details = error;
  }
  
}



// WEBPACK FOOTER //
// ./src/lib/paysafe/PaysafeError.js